import React from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useDroppable } from '@dnd-kit/core';
import { FaPlus, FaEdit, FaTrash, FaCopy, FaArrowLeft } from 'react-icons/fa';
import { useEffect, useRef } from 'react';
import { BlockText, BlockAlert, BlockImage, BlockSpace, 
  BlockMetrics, BlockVideo, BlockLoading, BlockPrice, BlockButton,
   BlockQuiz, BlockTestimonial,  BlockForm, BlockLevels, BlockCards, BlockScript } from '../../../../components/blocks';

// Block preview component
function BlockPreview({ block, className, settingsFunnel }) {


  if (block.type === 'button') { 
   
    return (
      
        <BlockButton block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
      
    );
  }

  if (block.type === 'text') {
    return (
       
        <BlockText block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'image') {
    return (
      
        <BlockImage block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'alert') {
    return (
      
        <BlockAlert block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'space') {
    return (
     
        <BlockSpace block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'metrics') {
    return (
      
        <BlockMetrics block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
        
    );
  }

  if (block.type === 'cards') {
    return ( 
        <BlockCards block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
    
    );
  }


  if (block.type === 'levels') {
    return (
     
        <BlockLevels block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
       
    );
  }

  if (block.type === 'video') {
    return (
      
        <BlockVideo block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'loading') {
    return (
 
        <BlockLoading block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
     
    );
  }

  if (block.type === 'price') {
    return ( 
        <BlockPrice block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
   
    );
  }

  if (block.type === 'quiz') {
    return ( 
        <BlockQuiz block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
      
    );
  }

  if (block.type === 'testimonial') {
    return ( 
        <BlockTestimonial block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
   
    );
  }

  if (block.type === 'form') {
    return (
 
        <BlockForm block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
      
    );
  }

  if (block.type === 'script') {
    return ( 
        <BlockScript block={block} className={className} isEditing={true} settingsFunnel={settingsFunnel} />
      
    );
  }
  // Default preview for other types
  return (
    <div className={`rounded-xl p-3 shadow bg-white w-full ${className || ''}`}>
      <div className="flex items-center gap-2">
        <span className="text-2xl">{block.icon}</span>
        <span className="font-medium">{block.label}</span>
      </div>
    </div>
  );
}

function HoverActions({ block, setConfigPanelOpen, setEditingBlock, duplicateBlock, handleBlockDelete, setEditingNodeId }) {
  return (
    <div className="absolute justify-center items-center w-full h-full flex gap-2 opacity-0 group-hover:opacity-100 border-2 border-blue-500 bg-blue-50 bg-opacity-50 transition-opacity z-10"
      style={{ pointerEvents: 'auto', borderRadius: '10px' }}
    >
      <button
        className="bg-blue-500 hover:bg-blue-600 text-white rounded p-2 shadow"
        title="Editar"
        onClick={e => {
          e.stopPropagation();
          setConfigPanelOpen(true);
          setEditingBlock(block);
       
        }}
      >
        <FaEdit />
      </button>
      <button
        className="bg-blue-500 hover:bg-blue-600 text-white rounded p-2 shadow"
        title="Duplicar"
        onClick={e => {
          e.stopPropagation();
          duplicateBlock(block);  
        }}
      >
        <FaCopy />
      </button>
      <button
        className="bg-blue-500 hover:bg-blue-600 text-white rounded p-2 shadow" 
        title="Remover"
        onClick={e => {
          e.stopPropagation();
          handleBlockDelete(block.id);
        }}
      >
        <FaTrash />
      </button>
    </div>
  );
} 

// Componente helper para tornar cada bloco sortable
function SortableItem({
  block,
  selectedBlockId,
  onBlockSelect,
  isGhost,
  setConfigPanelOpen,
  setConfigPanelBlock,
  setEditingBlock,
  duplicateBlock,
  handleBlockDelete,
  editingBlock, 
  setEditingNodeId,
  settingsFunnel,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: String(block.id),
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 100 : undefined,
    cursor: isDragging ? 'grabbing' : 'grab',
    position: 'relative',
    touchAction: 'none',
    width: '100%',
    height: 'auto',
    minHeight: '70px',
  };

 

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{
        ...style,
        opacity: isGhost ? 0.5 : 1,
        pointerEvents: isGhost ? 'none' : 'auto',
        overflow: 'hidden',
        marginBottom: `${settingsFunnel.spacing}px`
      }}
      id={`${block.id}`}
      className={`group rounded-xl ${
        isGhost
          ? 'border-2 border-dashed border-blue-500 bg-blue-50'
          : ''
      } flex items-center justify-between ${
        isDragging ? 'shadow-lg' : 'shadow'
      } relative overflow-hidden`}
      onMouseDown={() => {}}
       
    >
      <div className="flex-1 w-full" id={`preview-${block.id}`}>
        <BlockPreview
          block={block} 
          settingsFunnel={settingsFunnel}
        />
      </div>
      {/* Hover action buttons */}
      <div
        className="absolute justify-center items-center w-full h-full flex gap-2 opacity-0 group-hover:opacity-100 border-2 border-blue-500 bg-blue-50 bg-opacity-50 transition-opacity z-10"
        style={{ pointerEvents: 'auto', borderRadius: '10px' }}
      >
        {block.type !== 'empty' && (
        <HoverActions
          block={block}
          setConfigPanelOpen={setConfigPanelOpen}
          setEditingBlock={setEditingBlock}
          duplicateBlock={duplicateBlock}
          handleBlockDelete={handleBlockDelete}
          setEditingNodeId={setEditingNodeId}
        />    
        )}
       
      </div>
    </div>
  );
} 

export default function StepMobilePreview({
  blocks,
  setBlocks,
  onBlockSelect,
  selectedBlockId,
  nodes,
  setNodes,
  node,
  onNodeChange,
  setConfigPanelOpen,
  setConfigPanelBlock,
  setEditingBlock,
  duplicateBlock,
  handleBlockDelete,
  editingBlock,
  setEditingNodeId,
  funnel,
  settingsFunnel,
}) {

 

 let showLogo = node.data.showLogo ? true : false;
 let showProgress = node.data.showProgress ? true : false;
 let showBack = node.data.showBack ? true : false;

 let logo = settingsFunnel?.logo ? settingsFunnel.logo : null; 

 
  return (
    <div className="flex flex-col items-center mt-5  h-full mr-10">
      <div
        className="relative bg-black rounded-[2.5rem] shadow-2xl "
        style={{
          minWidth: 350,
          maxHeight: 700,
          height: '100%',
          border: '8px solid #222',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div
          className="absolute top-0 left-0 w-full h-full bg-white rounded-[2rem] overflow-y-scroll overflow-x-hidden scrollbar-none"
          style={{
            margin: 0,
            paddingTop: 36,
            paddingBottom: 24,
            zIndex: 1,
            boxSizing: 'border-box',
            minHeight: '100%',
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // IE 10+
            backgroundColor: settingsFunnel.backgroundColor,
            color: settingsFunnel.textColor,
            fontFamily: settingsFunnel.font,
          }}
        >
            <div className="flex flex-col px-4 w-full justify-center items-center "   >
                 
                 {showLogo && 
                 <div className="flex flex-row items-center justify-center w-full gap-3 " style={{marginBottom: `${settingsFunnel.spacing}px`}}>
                  {logo ? (
                    <img src={logo} alt="Logo"  style={{ width: `${settingsFunnel.logoWidth}px` }} />
                  ) : (
                    <div className="w-20 h-20 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg text-xs text-gray-400 bg-gray-50">
                      Sua Logo
                    </div>
                  )}
                 
                 </div>
                 }

                 {showProgress && nodes && nodes.length > 1 && (
                   <div className="flex flex-row px-4 w-full justify-center items-center" style={{marginBottom: `${settingsFunnel.spacing}px`}}>
                     <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                       <div
                         className="h-2   transition-all duration-300" 
                         style={{
                          background: settingsFunnel.primaryColor,
                           width: `${
                             Math.round(
                               ((nodes.findIndex(n => n.id === node.id) + 1) / nodes.length) * 100
                             )
                           }%`
                         }}
                       ></div>
                     </div>
                     
                   </div>
                 )}

                 
                 {showBack && 
                 <div className="flex flex-row items-center justify-center absolute top-10 left-5">
                   <div className="w-10 h-10 rounded-full">
                     <FaArrowLeft style={{color: settingsFunnel.primaryColor}} />
                   </div>
                 </div>
                 }
                
            </div>
          <SortableContext
            items={blocks.map(b => String(b.id))}
            strategy={verticalListSortingStrategy}
          >
            <div
              className="flex flex-col  px-4"
              id="dnd-sortable-context"
            >
            
              {blocks.length > 0 ? (
                blocks.map(block => (
                  <SortableItem
                    key={block.id}
                    block={block}
                    editingBlock={editingBlock}
                    setEditingBlock={setEditingBlock}
                    selectedBlockId={selectedBlockId}
                    onBlockSelect={onBlockSelect}
                    setConfigPanelOpen={setConfigPanelOpen}
                    setConfigPanelBlock={setConfigPanelBlock}
                    duplicateBlock={duplicateBlock}
                    handleBlockDelete={handleBlockDelete} 
                    setEditingNodeId={setEditingNodeId}
                    settingsFunnel={settingsFunnel}
                  />
                ))
              ) : (
                 <SortableItem
                key={'empty'}
                block={{
                    id: 'empty',
                    type: 'empty',
                    label: 'Para começar, adicione um bloco',
                    icon: '🚀',
                }}
                editingBlock={editingBlock}
                setEditingBlock={setEditingBlock}
                selectedBlockId={selectedBlockId}
                onBlockSelect={onBlockSelect}
                setConfigPanelOpen={setConfigPanelOpen}
                setConfigPanelBlock={setConfigPanelBlock}
                duplicateBlock={duplicateBlock}
                handleBlockDelete={handleBlockDelete} 
                setEditingNodeId={setEditingNodeId}
                settingsFunnel={settingsFunnel}
                />
              )}
            </div>
          </SortableContext>
        </div>
      </div>
    </div>
  );
}